<mat-card>
  <mat-card-header>
    <mat-card-title
      i18n="component formulaire link utilisateur société | titre"
    >
      Lié un utilisateur à votre société
    </mat-card-title>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <form [formGroup]="form" (submit)="submit()">
      <p>
        <mat-form-field appearance="outline">
          <mat-label i18n="formulaire d'inscription | champ">email</mat-label>
          <input
            matInput
            type="email"
            placeholder="me@mail.com"
            formControlName="email"
          />
          <mat-icon matSuffix>mail</mat-icon>
          <mat-error>
            @for (errorMsg of authMsg.email; track errorMsg) { @if
            (email.hasError(errorMsg.type)) {
            <span>
              {{ errorMsg.msg }}
            </span>
            } }
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label i18n="formulaire d'inscription | champ">prénom</mat-label>
          <input matInput placeholder="John" formControlName="firstName" />
          <mat-icon matSuffix>person</mat-icon>
          <mat-error>
            @for (errorMsg of authMsg.firstName; track errorMsg) { @if
            (firstName.hasError(errorMsg.type)) {
            <span>
              {{ errorMsg.msg }}
            </span>
            } }
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label i18n="formulaire d'inscription | champ">nom</mat-label>
          <input
            matInput
            type="email"
            placeholder="Doe"
            formControlName="lastName"
          />
          <mat-icon matSuffix>group</mat-icon>
          <mat-error>
            @for (errorMsg of authMsg.lastName; track errorMsg) { @if
            (lastName.hasError(errorMsg.type)) {
            <span>
              {{ errorMsg.msg }}
            </span>
            } }
          </mat-error>
        </mat-form-field>
      </p>
      <mat-divider></mat-divider>
      <mat-card-actions>
        <button
          mat-flat-button
          type="button"
          (click)="cancel()"
          i18n="component formulaire link utilisateur société | bouton"
        >
          annuler
        </button>
        <button
          mat-flat-button
          type="submit"
          color="primary"
          [disabled]="form.invalid"
          i18n="component formulaire link utilisateur société | bouton"
        >
          lier
        </button>
      </mat-card-actions>
    </form>
  </mat-card-content>
  <mat-card-footer>
    @if (formInProgress) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </mat-card-footer>
</mat-card>
